import { Box, Button, Card, ReadOnlyField } from '@oresundsbron/bridge-ui';
import { Close, Car } from '@oresundsbron/icons';
import { FC } from 'react';
import { Alpr, Labels } from './types';
import { isVehicleNameEmpty } from './utils';

export const AlprEntry: FC<
  {
    labels: Labels;
    onRemove: () => void;
    disabled?: boolean;
    alprName?: string;
  } & Alpr
> = ({
  labels,
  licensePlate,
  alprName,
  paymentOptions,
  onRemove,
  disabled,
}) => (
  <Card.Root className="col-span-full">
    <Card.Content className="flex flex-row items-center justify-between">
      <Box className={'pr-5'}>
        <Car className="text-2xl text-primary-600" />
      </Box>
      <Box className={'flex-1'}>
        <ReadOnlyField
          label={
            isVehicleNameEmpty(alprName) ? labels.licensePlate : labels.alprName
          }
        >
          {isVehicleNameEmpty(alprName) ? licensePlate : alprName}
        </ReadOnlyField>
        {paymentOptions === 'bizz' ? (
          <ReadOnlyField label={labels.bizz}>
            {labels.bizzOrdered}
          </ReadOnlyField>
        ) : null}
      </Box>
      <Box className="flex flex-row items-center">
        <Button
          startIcon={<Close />}
          iconSize="lg"
          color="neutral"
          intent="text"
          aria-label={labels.remove}
          onClick={onRemove}
          disabled={disabled}
        />
      </Box>
    </Card.Content>
  </Card.Root>
);
